
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gUz07gr8Fw0sTw2TCSlYeXkRn8u_OWQq7F_45kPt6nc2zAMeta } from "/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index_45ZW1k5IDoT5AbwBaBSbhClUIDLYIkTzAw_V9iev8zKQMeta } from "/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchgcz65pT8n2SxtxB4bdueZb_458cKAxwKvIWXY1ewKPGocMeta } from "/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexdygqKAjoT3o_UN_45olIBYa86l3OhAceVeyP6Xb78weQIMeta } from "/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93NtHure0_45uVjl0e7DfnFuH3NnEA_45P2cyNtesDoBsZJyAMeta } from "/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexCc7pqM55uDRCqObOWZ_45aPL2GDsZARjpfeL3QdtVryKcMeta } from "/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_932biVQuof_L2sF5r5ShuGh5CbJCeuVoZDRD72saP8gOwMeta } from "/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index2lFMU022mhHpZsmQfxyc_9X15WiI8mWcRYjFlMYnWnYMeta } from "/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93j5Y_45spPG3BQvd0o1NML_uVWFkgOUVRR_hmQpmSZDStoMeta } from "/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexVXqb5HoppE7RME5YvGVeIfOTeu4mDFj75gzVb2Q1o5IMeta } from "/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexg8F_45i5IgYvkcUueL6DfGlfbGFUkktob810o7nB5RNkUMeta } from "/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexCc7pqM55uDRCqObOWZ_45aPL2GDsZARjpfeL3QdtVryKcMeta || {},
    component: () => import("/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index2lFMU022mhHpZsmQfxyc_9X15WiI8mWcRYjFlMYnWnYMeta || {},
    component: () => import("/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexVXqb5HoppE7RME5YvGVeIfOTeu4mDFj75gzVb2Q1o5IMeta || {},
    component: () => import("/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexg8F_45i5IgYvkcUueL6DfGlfbGFUkktob810o7nB5RNkUMeta || {},
    component: () => import("/codebuild/output/src2839951266/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]